import { render, staticRenderFns } from "./stockTurnRateList.vue?vue&type=template&id=7c6a0d1e&scoped=true"
import script from "./stockTurnRateList.vue?vue&type=script&lang=js"
export * from "./stockTurnRateList.vue?vue&type=script&lang=js"
import style0 from "./stockTurnRateList.vue?vue&type=style&index=0&id=7c6a0d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a0d1e",
  null
  
)

export default component.exports